module.exports = __webpack_public_path__ + "img/bj_ej.5cc11499.png";